import { createAsyncThunk } from '@reduxjs/toolkit';
import type { FetchResponse } from '@cian/http-api';
import { IThunkApi } from '../../types/redux';
import { fetchValidateAddressWeb } from '../../../common/repositories/price-estimator/v1/validate-address-web';
import type { TValidateAddressWebResponse } from '../../../common/repositories/price-estimator/v1/validate-address-web/types';
import { fetchGetFlatAreasDesktop } from '../../../common/repositories/price-estimator/v1/get-flat-areas-desktop';
import type { TGetFlatAreasDesktopResponse } from '../../../common/repositories/price-estimator/v1/get-flat-areas-desktop/types';
import { setError, setFlatAreasSuccessResponse, setHouseId } from '../../slices';

export const getFlatAreasSuggest = createAsyncThunk<void, string, IThunkApi>(
  'getFlatAreasSuggest',
  async (selectedAddress, _thunkApi) => {
    const {
      extra: { httpApi, logger },
      dispatch,
    } = _thunkApi;

    return fetchValidateAddressWeb({
      httpApi,
      parameters: { address: selectedAddress },
    })
      .then(rawResponse => {
        const response = rawResponse as FetchResponse<TValidateAddressWebResponse>;

        if (response.statusCode === 200) {
          dispatch(setHouseId(response.response.houseId));

          return fetchGetFlatAreasDesktop({
            httpApi,
            parameters: { address: selectedAddress },
          });
        }

        return Promise.reject(response);
      })
      .then(rawResponse => {
        const response = rawResponse as FetchResponse<TGetFlatAreasDesktopResponse>;

        if (response.statusCode === 200) {
          const { flatAreas } = response.response;

          dispatch(setFlatAreasSuccessResponse({ flatAreas: flatAreas ?? undefined }));
        }
      })
      .catch(response => {
        if (response.statusCode === 400) {
          const errors = response.response.errors || [];
          const error = errors[0] || {};
          const { key, message } = error;

          if (key && message) {
            dispatch(
              setError({
                currentErrorField: key,
                errorText: message,
              }),
            );
          }
        } else {
          logger.error(response);
        }
      });
  },
);
